import { jsxs as l, jsx as c } from "react/jsx-runtime";
const t = ({ size: a = 24 }) => /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: a, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: "#FFC547",
      d: "m594.944 0 335.124 341.32v563.2c0 65.996-52.5 119.48-117.294 119.48H209.546c-64.793 0-117.299-53.53-117.299-119.48V119.48C92.252 53.484 144.757 0 209.551 0h385.393z"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      fill: "#FFF",
      fillOpacity: 0.4,
      d: "M930.068 341.32H718.152c-64.748 0-123.208-59.49-123.208-125.492V0l335.124 341.32z"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      fill: "#FFF",
      d: "M568.78 446.464V675.84a27.238 27.238 0 0 1-6.793 18.248 45.66 45.66 0 0 1-17.316 12.38 112.64 112.64 0 0 1-20.803 6.518c-6.937 1.438-13.404 2.186-19.41 2.186-6.052 0-12.523-.748-19.41-2.14a112.456 112.456 0 0 1-20.807-6.564 45.706 45.706 0 0 1-17.316-12.38 27.228 27.228 0 0 1-6.84-18.248c0-6.84 2.33-12.892 6.84-18.248a45.706 45.706 0 0 1 17.316-12.38c6.983-2.934 13.916-5.12 20.807-6.518 6.887-1.484 13.358-2.186 19.405-2.186 14.06 0 26.952 2.652 38.636 8.008V534.528l-154.481 48.548v145.218a27.228 27.228 0 0 1-6.8 18.202 45.66 45.66 0 0 1-17.315 12.38 112.64 112.64 0 0 1-20.803 6.564c-6.937 1.398-13.404 2.14-19.41 2.14-6.052 0-12.523-.696-19.41-2.14a112.502 112.502 0 0 1-20.807-6.518 45.706 45.706 0 0 1-17.311-12.426 27.233 27.233 0 0 1-6.845-18.248c0-6.794 2.33-12.892 6.845-18.196a45.706 45.706 0 0 1 17.31-12.38c6.984-2.934 13.922-5.12 20.808-6.564a94.802 94.802 0 0 1 19.405-2.14c14.06 0 26.957 2.652 38.636 7.956V498.872a19.876 19.876 0 0 1 13.685-18.846l167.286-52.414a17.63 17.63 0 0 1 5.581-.84c5.402 0 9.964 1.91 13.686 5.73 3.773 3.86 5.632 8.468 5.632 13.962z"
    }
  )
] });
export {
  t as AudioIcon
};
//# sourceMappingURL=AudioIcon.js.map
